module.exports = __webpack_public_path__ + "static/media/bar.1377ef57.jpg";